import { useEffect, useRef } from "react";

export function useGlobalMouse() {
    const ref = useRef(false);
    useEffect(() => {
        const down = () => (ref.current = true);
        const up = () => (ref.current = false);

        window.addEventListener("mousedown", down);
        window.addEventListener("mouseup", up);
        window.addEventListener("blur", up);

        return () => {
            window.removeEventListener("mousedown", down);
            window.removeEventListener("mouseup", up);
            window.removeEventListener("blur", up);
        };
    }, []);
    return {
        isDown: () => ref.current
    };
}